import React from 'react';
import Loader from 'kepler/lib/components/Loader';
import PropTypes from 'prop-types';

export default function connectDataFetchers(Component, actionCreators) {
  class DataFetchersWrapper extends React.Component {
    state = {
      loading: !Object.keys(this.props.tools).length
    };

    static fetchData(dispatch, params = {}, query = {}, headers = {}) {
      return Promise.all(
        actionCreators.map(actionCreator =>
          dispatch(actionCreator(params, query, headers))
        )
      );
    }

    componentDidMount() {
      if (this.state.loading) {
        DataFetchersWrapper.fetchData(
          this.props.dispatch,
          this.props.params,
          this.props.location.query
        ).then(() => {
          this.setState({
            loading: false
          });
        });
      }
    }

    render() {
      if (this.state.loading) {
        return (
          <div>
            <Loader show={this.state.loading} type="absolute" priority={10} />
            <Component {...this.props} />
          </div>
        );
      }
      return <Component {...this.props} />;
    }
  }

  DataFetchersWrapper.propTypes = {
    dispatch: PropTypes.func.isRequired,
    params: PropTypes.object,
    location: PropTypes.object.isRequired,
    tools: PropTypes.object
  };

  return DataFetchersWrapper;
}
